import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogTitle } from '@angular/material/dialog';
import { MatDialogContent } from '@angular/material/dialog';
import { MatDialogActions } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatDialogTitle, MatDialogContent, MatDialogActions]
})
export class ConfirmationDialogComponent {

  public title: string = '';

  public content: string = '';

  public confirmLabel: string = 'Confirm';

  public cancelLabel: string = 'Cancel';

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    title: string;
    content: string;
    confirmLabel?: string;
    cancelLabel?: string;
  }) {
    if (data.title) this.title = data.title;
    if (data.content) this.content = data.content;
    if (data.confirmLabel) this.confirmLabel = data.confirmLabel;
    if (data.cancelLabel) this.cancelLabel = data.cancelLabel;
  }

}
